import { Component, computed, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter, map } from "rxjs";
import { TextComponent } from "../../typography/text/text.component";

@Component({
  selector: "app-navbar-logo",
  templateUrl: "./navbar-logo.component.html",
  styleUrl: "./navbar-logo.component.scss",
  imports: [TextComponent],
  host: {
    "[class.navbar-logo--visible]": "show()",
  },
})
export class NavbarLogoComponent {
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  private currentUrl = toSignal(
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map((event) => (event as NavigationEnd).urlAfterRedirects),
    ),
    { initialValue: this.router.url },
  );

  private isFromApp = toSignal(
    this.route.queryParams.pipe(map((params) => params["origin"] === "app")),
    { initialValue: this.route.snapshot.queryParams["origin"] === "app" },
  );

  show = computed(() => {
    if (this.isFromApp()) return false;

    const url = this.currentUrl();
    return url.startsWith("/checkout") || /^\/orcamentos\/[^/]+\/detalhes/.test(url);
  });
}
